let statusPillRenderTemplate = require("./html/statusPillsTemplate.html");
let createdOnRenderTemplate = require("./html/createdOnTemplate.html");
import render from "../../utilities/render";
//Changes for Date and Time Display in bulkupload landing page
import moment from "moment";
const datTimeFormat = "MM/DD/YYYY hh:mm A";

  let date = new Date();
  let pillStatusClasses = {
  "Complete": "q-pill-green",
  "Partially Complete": "q-pill-blue-border",
  "Processing": "q-pill-blue-border",
  "Failed": "q-pill-red",
}
export const filterData = [
  {
    "filterGroup": "Upload Status",
    "filterGroupType": "checkbox",
    "filterGroupName": "status",
    "filterGroupInputs": [
      {
        "filterTitle": "Processing",
        "filterValue": "Received",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterTitle": "Partially Complete",
        "filterValue": "PartiallyProcessed",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterTitle": "Complete",
        "filterValue": "Processed",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterTitle": "Failed",
        "filterValue": "Failed",
        "filterOperator": "equal",
        "active": false
      },
    ],
  },
  {
    "filterGroup": "Upload Type",
    "filterGroupType": "checkbox",
    "filterGroupName": "type",
    "filterGroupInputs": [
      {
        "filterTitle": "Orders",
        "filterValue": "ORDER",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterTitle": "Items",
        "filterValue": "ITEMS",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterTitle": "Products",
        "filterValue": "PRODUCT",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterTitle": "Inbound Shipments",
        "filterValue": "ASN",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterTitle": "Facilities",
        "filterValue": "FACILITIY",
        "filterOperator": "equal",
        "active": false
      }
    ],
  },
  {
    "filterGroup": "Date Range",
    "filterGroupType": "radio",
    "filterGroupName": "createdTimeStamp",
    "filterGroupInputs": [
      {
        "filterName": "fixedRange",
        "filterTitle": "Today",
        "filterValue": "today",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterName": "fixedRange",
        "filterTitle": "Yesterday",
        "filterValue": "yesterday",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterName": "fixedRange",
        "filterTitle": "Last 7 Days",
        "filterValue": "lastSevenDays",
        "filterOperator": "equal",
        "active": false
      },
      {
        "filterName": "fixedRange",
        "filterTitle": "Last 60 Days (Default)",
        "filterValue": "lastSixtyDays",
        "filterOperator": "equal",
        "active": true
      },
      {
        "filterName": "fixedRange",
        "filterTitle": "Custom Date Range",
        "filterValue": "customRange",
        "filterOperator": "equal",
        "active": false,
        "childFilters":[
          {
            "filterGroup": "Date Range",
            "filterGroupType": "dateRange",
            "filterGroupName": "createdTimeStamp",
            "dateRangeNameStart": "startDate",
            "dateRangeNameEnd": "endDate" 
          }
        ]
      },
    ],
  }
];

export const columnData = [
   {
    data: "bupDisplayId",
    title: "Upload ID",
    linkKey: "lookupTableActionLink",
    canToggle: false
    },
    {
      data: "type",
      title: "Upload Type",
    },
    {
      data: "records",
      title: "Records",
      render: renderSetDash
    },
    {
      data: "createdTimeStamp",
      title: "Created On",
      render: createdOnRender
    },
    {
      data: "status",
      title: "Status",
      render: statusPillRender
    },
  
];

  function renderSetDash(data, type, row) {
    if (data === 0 || data === "0" || typeof data === "undefined") {
      return "-";
    };
    return data
  }

  function createdOnRender(data, type, row) {
    let checkDate = new Date(data);
    let newDate = dateDiff(date, checkDate);
    let pillDate;
    if (newDate >= 0) {
      if (newDate === 0) {
        pillDate = 'Today';
      } else if (newDate === 1) {
        pillDate = 'Yesterday';
      } else {
        pillDate = newDate + ' days ago';
      }
      data =moment(data).format(datTimeFormat) + " ET";
    }
    let newRender;
    return newRender = render(
      createdOnRenderTemplate, {
        data,
        pillDate
      }
    );
  }

  export    function statusPillRender(data, type, row) {
    let newRender;
    let pillClass = pillStatusClasses[data];
    return newRender = render(
      statusPillRenderTemplate, {
        data,
        pillClass
      }
    );
  }

  function dateDiff(date1, date2) {
    date1.setHours(0);
    date1.setMinutes(0, 0, 0);
    date2.setHours(0);
    date2.setMinutes(0, 0, 0);
    let datediff = Math.abs(date1.getTime() - date2.getTime());
    return parseInt(datediff / (24 * 60 * 60 * 1000), 10);
  }


// WEBPACK FOOTER //
// ./src/pages/bulkUpload/initialData.js